import { useQuery } from '@/react-query/hooks/useQuery/useQuery';
import { logQueries } from '@/services/logsManagement/logsManagement.queries';

export const useApiLogs = () => {
  const { data, isFetched } = useQuery({
    ...logQueries.api,
  });

  return {
    apiLogs: data?.data || [],
    isFetched,
  };
};
